<template>
  <component
    v-for="(section, idx) in sections"
    :key="idx"
    :is="section.component"
    v-bind="section.props || {}"
  />
</template>

<script setup>
import { computed } from 'vue'
import resolveComponents from '../scripts/resolveComponents'
import setProps from '../scripts/setProps'
import DynamicPageUtils from '@/shared/utils/dynamicPageUtils'

const props = defineProps({
  theme: {
    type: Object,
    default: () => ({}),
  },
  page: {
    type: Object,
    required: true,
  },
})

const sections = computed(() => {
  const formatted = setProps(props.page.layout)
  const componentsResolvedConf = resolveComponents(formatted)
  return componentsResolvedConf
})

if (props.theme) {
  DynamicPageUtils.setTheme(props.theme)
}
if (props.page.theme) {
  DynamicPageUtils.mergeTheme(props.page.theme)
}
</script>
